import { render, staticRenderFns } from "./FirmwaresForm.vue?vue&type=template&id=19febee6&scoped=true&"
import script from "./FirmwaresForm.vue?vue&type=script&lang=ts&"
export * from "./FirmwaresForm.vue?vue&type=script&lang=ts&"
import style0 from "./FirmwaresForm.vue?vue&type=style&index=0&id=19febee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19febee6",
  null
  
)

export default component.exports